// import React from "react";
// import {
//   // FaFacebookF,
//   // FaInstagram,
//   // FaLinkedinIn,
//   // FaTwitter,
//   FaMailBulk,
// } from "react-icons/fa";
// import {
//   AiOutlineFacebook,
//   AiOutlineInstagram,
//   AiOutlineTwitter,
//   AiOutlineLinkedin,
// } from "react-icons/ai";

// import { NavLink } from "react-router-dom";

// const Footer = () => {
//   return (
//     <>
//       <footer className="banner mt-5">
//         <div className="footer container-fluid footer text-light p-4 h-100">
//           <div className="row">
//             <div className="col-md-4 col-12 ">
//               <h5>About Us</h5>
//               <hr />
//               <p className="w-75">
//                 मराठवाड्यातील आठही जिल्हे नेहमीच दुष्काळ ग्रस्त आहेत या
//                 संकटामुळे लाखोंच्या संख्येने नागरिक नाशिक, पुणे, मुंबई, छत्रपती
//                 संभाजीनगर, नागपूर इत्यादी शहरांमध्ये स्थलांतर करतात. या
//                 स्थलांतरामुळे ग्रामीण भागात विकास खुंटतो, आणि शहरात स्थलांतरित
//                 झालेल्या नागरिकांना अनेक अडचणींचा सामना करावा लागतो.
//               </p>
//               <hr />
//               <div className="d-flex mt-4">
//                 <p className="">Follow Us - </p>

//                 <div className="d-flex me-2">
//                   <a
//                     href="https://www.facebook.com/profile.php?id=100094476235504"
//                     target="_blank"
//                     rel="noreferrer"
//                   >
//                     <AiOutlineFacebook
//                       className="fs-3 me-2 text-white rounded-2 "
//                       style={{ backgroundColor: "#3B5998" }}
//                     />
//                   </a>
//                   <a
//                     href="https://www.instagram.com/yuvasarathi_official/"
//                     target="_blank"
//                     rel="noreferrer"
//                   >
//                     <AiOutlineInstagram
//                       className="fs-3 me-2 text-white rounded-2"
//                       style={{ backgroundColor: " #bc2a8d" }}
//                     />
//                   </a>
//                   <a
//                     href="https://twitter.com/theinnovatives3?t=ZQHRr29rvQHbPC8qRTnpJg&s=09"
//                     target="_blank"
//                     rel="noreferrer"
//                   >
//                     <AiOutlineTwitter
//                       className="fs-3 me-2  text-white rounded-2"
//                       style={{ backgroundColor: " #55ACEE" }}
//                     />
//                   </a>
//                   <a
//                     href="https://www.linkedin.com/in/the-innovative-solutions-18255222a/"
//                     target="_blank"
//                     rel="noreferrer"
//                   >
//                     <AiOutlineLinkedin
//                       className="fs-3 me-2  text-white rounded-2"
//                       style={{ backgroundColor: "#0077b5" }}
//                     />
//                   </a>
//                 </div>
//               </div>
//               <p className="mt-3 fw-bold">
//                 <FaMailBulk /> enquiry@theinnovativesolutions.in
//               </p>
//             </div>
//             <div className="footerlinks col-md-4 col-12 ">
//               <h5>Quick Links</h5>
//               <hr />
//               <li>
//                 <NavLink to="/" className="text-decoration-none text-light">
//                   Home
//                 </NavLink>
//               </li>
//               <br />

//               <li>
//                 <NavLink
//                   to="/about"
//                   className="text-decoration-none text-light"
//                 >
//                   About Us
//                 </NavLink>
//               </li>
//               <br />
//               <li>
//                 <NavLink
//                   to="/merchants"
//                   className="text-decoration-none text-light"
//                 >
//                   Merchants
//                 </NavLink>
//               </li>
//               <br />

//               <li>
//                 <NavLink
//                   to="/internships"
//                   className="text-decoration-none text-light"
//                 >
//                   Internships
//                 </NavLink>
//               </li>
//               <br />
//               <li>
//                 <NavLink to="/jobs" className="text-decoration-none text-light">
//                   Jobs
//                 </NavLink>
//               </li>
//               <br />
//               <li>
//                 <NavLink
//                   to="/contact"
//                   className="text-decoration-none text-light"
//                 >
//                   Contact Us
//                 </NavLink>
//               </li>

//               <br />
//             </div>
//             <div className="map col-md-4 col-12 ">
//               <h5 href="">Find direction</h5>
//               <hr />
//               <br />
//               <div className="map-responsive">
//                 <iframe
//                   className="gmap_iframe border p-2"
//                   width="350px"
//                   height="300px"
//                   src="https://maps.google.com/maps?width=435&amp;height=414&amp;hl=en&amp;q=the innovative solutions nashik&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
//                 ></iframe>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="container-fluid text-center text-dark bg-light p-1">
//           <p>
//             © 2023 The Innovative Solutions | All Rights Reserved | Terms &
//             Conditions | Privacy Policy
//           </p>
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Footer;

import React from "react";

const Footer = () => {
  return (
    <div>
      <footer className="text-center text-lg-start text-white bg-danger">
        <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
          <div className="me-5 d-none d-lg-block">
            <span>Get connected with us on social networks:</span>
          </div>

          <div>
            <a href="" className="me-4 text-reset">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="" className="me-4 text-reset">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="" className="me-4 text-reset">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="" className="me-4 text-reset">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </section>
        <section className="">
          <div className="container text-center text-md-start mt-5">
            <div className="row mt-3">
              <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">
                  मराठवाडा सामाजिक फाऊंडेशन, महाराष्ट्र
                </h6>
                <p style={{ textAlign: "justify" }}>
                  मराठवाड्यातील आठही जिल्हे नेहमीच दुष्काळ ग्रस्त आहेत या
                  संकटामुळे लाखोंच्या संख्येने नागरिक नाशिक, पुणे, मुंबई,
                  छत्रपती संभाजीनगर, नागपूर इत्यादी शहरांमध्ये स्थलांतर करतात.
                  या स्थलांतरामुळे ग्रामीण भागात विकास खुंटतो, आणि शहरात
                  स्थलांतरित झालेल्या नागरिकांना अनेक अडचणींचा सामना करावा
                  लागतो. कोरोना महामारीने पुर्ण जगाला घेरून घेतले होते.
                </p>
              </div>
              <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Quick links</h6>
                <p>
                  <a href="#!" className="text-reset">
                    About
                  </a>
                </p>
                <p>
                  <a href="#!" className="text-reset">
                    News
                  </a>
                </p>
                <p>
                  <a href="#!" className="text-reset">
                    Donation
                  </a>
                </p>
                <p>
                  <a href="#!" className="text-reset">
                    Membership
                  </a>
                </p>
              </div>

              <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
                <p>
                  <i className="fas fa-home me-3"></i>व्रज लाइफ स्पेस, शॉप नं.
                  ११६, आर.टी.ओ. ऑफीस समोर, पेठरोड, नाशिक ३
                </p>
                <p>
                  <i className="fas fa-envelope me-3"></i>
                  marathwadasfoundation@gmail.com
                </p>
                <p>
                  <i className="fas fa-phone me-3"></i>९५४५८३४२२२ / ९६३७९५४८७७
                </p>
              </div>
              <div className="col-md-4">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d119949.70496072363!2d73.65098844335938!3d20.032496100000007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bddeba961191f75%3A0xbfa7ce35d9b214b0!2sVraj%20Life%20Space!5e0!3m2!1sen!2sin!4v1749883125576!5m2!1sen!2sin"
                  width="350"
                  height="300"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        <div
          className="text-center bg-white text-dark p-2"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.05);" }}
        >
          © 2025 Copyright:
          <a
            className="text-reset fw-bold"
            href="https://theinnovativesolutions.in/"
          >
            The Innovative Solutions, Nashik
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
